<script setup lang="ts">
import { tracking } from '~/services/tracking.client'

import type {ProductListMiniInterface} from "~~/server/types/Products";
import {usePrice} from "~/composables/usePrice";

const { format: price,oldPrice } = usePrice();

const props = defineProps<{
    list: ProductListMiniInterface[];
}>();


const trackingRoute = useRoute()
const trackingListId = () => `products:${trackingRoute.path}`
onMounted(() => {
    let previousList = ''
    watch(() => props.list, list => {
        const key = list.map(item => item.id).join(',')
        if (key !== previousList) {
            previousList = key
            tracking.viewItemList(list, trackingListId())
        }
    }, { immediate: true })
})
</script>

<template>
    <div class="product-list">
        <article
                v-for="item in props.list"
                :key="item.id"
                class="product-list-item  pb-2 border-bottom"
        >

            <!-- Image -->
            <NuxtLinkLocale @click="tracking.selectItem(item, trackingListId(), props.list.findIndex(p => p.id === item.id))" :to="`${item.url}`" class="image-wrap">
                <img
                        :src="item.icon"
                        :alt="item.name"
                        loading="lazy"
                        style="object-fit: contain;"
                />
            </NuxtLinkLocale>

            <!-- Info -->
            <div class="content">
                <NuxtLinkLocale @click="tracking.selectItem(item, trackingListId(), props.list.findIndex(p => p.id === item.id))" :to="`${item.url}`">
                   <el-text class="fs--11" style="color: var(--el-color-link)">{{ item.name }}</el-text>
                </NuxtLinkLocale>
                  <div class="price-row mt-2">
                    <el-tag v-if="item.discount" effect="dark" round  class="fw-bold fs--1 discount-badge"  >
                      {{ item.discount * -1 }} %
                    </el-tag>
                    <div>
                      <el-text  class="fw-bold fs-0 me-2" type="primary" >
                        {{ price(item.price) }}
                      </el-text>
                      <el-text  v-if="item.discount" class="old_price fs--1 fw-semibold" type="info">
                        {{price(oldPrice(item.price,item.discount || 0))}}
                      </el-text>
                    </div>


                </div>
            </div>
        </article>
    </div>
</template>


<style scoped lang="scss">
.product-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.product-list-item {
  display: flex;
  align-items: center;
  gap: 16px;

}

.image-wrap {
  width: 60px;
  height: 60px;
  flex-shrink: 0;

  img {
    width: 100%;
    height: 100%;
  }
}

.content {
  display: flex;
  flex-direction: column;
  flex: 1;
}
.price-row {
  display: flex;
   align-items: center;
  gap:10px;
}
.old_price {
  text-decoration: line-through;
  color: var(--el-color-info);
}
</style>

